import classNames from "classnames";
import { ButtonHTMLAttributes, CSSProperties } from "react";
import React from "react";
import styles from "./agentButton.css";

export interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  fullWidth?: boolean;
  buttonStyle?: StyleType;
  icon?: string;
  small?: boolean;
  textStyle?: CSSProperties;
}

type StyleType =
  | "primary"
  | "outlined primary"
  | "outlined secondary"
  | "outlined red"
  | "outlined tertiary"
  | "transparent primary"
  | "transparent secondary"
  | "transparent error"
  | "big orange"
  | "big orange outlined"
  | "orange normal";

export class AgentButton extends React.Component<Props, {}> {
  button: HTMLButtonElement | undefined = undefined;

  constructor(props: Props) {
    super(props);
  }

  getStyle(buttonStyle?: StyleType): string {
    switch (buttonStyle) {
      case "primary":
        return styles.primary;
      case "outlined primary":
        return styles["outlined-primary"];
      case "outlined red":
        return styles["outlined-red"];
      case "outlined secondary":
        return styles["outlined-secondary"];
      case "outlined tertiary":
        return styles["outlined-tertiary"];
      case "transparent primary":
        return styles["transparent-primary"];
      case "transparent secondary":
        return styles["transparent-secondary"];
      case "transparent error":
        return styles["transparent-error"];
      case "big orange":
        return styles["big-orange"];
      case "big orange outlined":
        return styles["big-orange-outlined"];
      case "orange normal":
        return styles["normal-orange"];
      default:
        return styles.primary;
    }
  }

  focus() {
    if (this.button) {
      this.button.focus();
    }
  }

  offsetWidth() {
    return (this.button && this.button.offsetWidth) || 0;
  }

  render() {
    const { fullWidth, buttonStyle, icon, small, type, children, textStyle, ...restProps } =
      this.props;
    const buttonClass = classNames(styles["agent-button"], this.getStyle(buttonStyle), {
      [styles["full-width"]]: fullWidth,
      [styles.small]: small
    });

    return (
      <button
        type={type || "button"}
        className={buttonClass}
        ref={(e) => (this.button = e || undefined)}
        {...restProps}
      >
        {icon && (
          <div className={classNames(styles.icon, !!children ? styles["margin-right"] : "")}>
            <i className={icon} />
          </div>
        )}
        <div
          className={classNames(styles.text, icon !== undefined ? styles["margin-right"] : "")}
          style={textStyle}
        >
          {children}
        </div>
      </button>
    );
  }
}
